const ACTIONS = {
  CHOSE_POKEMON_NAME: 'CHOSE_POKEMON_NAME',
  CHOSE_LETTER: 'CHOSE_LETTER'
};

export default ACTIONS;